<template>
  <div class="post-container">
    <div 
      class="status-indicator" 
      :class="{
        'status-pending': post.status === 'pending',
        'status-approved': post.status === 'approved',
        'status-rejected': post.status === 'rejected'
      }"
    ></div>

    <div class="preview-container" @click="$emit('handleClick')">
      <img 
        v-if="post.mediaUrl.includes('.png') || post.mediaUrl.includes('.jpg') || post.mediaUrl.includes('.jpeg') && post.mediaUrl"
        :src="post.mediaUrl"  
        alt="Preview"
        class="preview-media"
      >
      <img 
        v-else-if="post.mediaUrl.includes('.mp4') && post.videoThumbnail"
        :src="post.videoThumbnail"
        alt="Video Thumbnail"
        class="preview-media"
      >
      <div v-else-if="post.mediaUrl.includes('.mp4') && post.mediaUrl" class="video-preview-wrapper">
        <video class="preview-media">
          <source :src="post.mediaUrl" type="video/mp4">
          Ihr Browser unterstützt keine Videos.
        </video>
        <div class="play-button-overlay">
          <div class="play-button">
            <i class="fas fa-play"></i>
          </div>
        </div>
      </div>
      <div v-else class="no-media">
        Keine Medienvorschau verfügbar
      </div>
    </div>

    <div class="content" @click="$emit('handleClick')" style="position: relative">
      <p class="post-content line-clamp" style="margin-top: 10px" :style="{'font-size': isMobile ? '13px' : ''}">{{ post.text }}</p>
      <p class="schedule-time" :style="{'font-size': isMobile ? '12px' : '15px'}" style="position: absolute; left: 10px; bottom: 15px">
        Geplant für: {{ formatDateTime(post.publicationDate.dateTime) }}
      </p>
    </div>

    <!-- <div class="button-container">
      <button 
        @click="approvePost" 
        class="action-button approve"
      >
        Freigeben
      </button>
      <button 
        @click="showNote = true" 
        class="action-button reject"
      >
        Korrektur notwendig
      </button>
    </div> -->

    <!-- Ablehnnotiz Modal -->
    <div class="modal-overlay" v-if="showNote" @click.self="showNote = false">
      <div class="note-modal-content">
        <h2>
          Was soll geändert werden?
        </h2>
        <textarea style="padding: 15px; border-radius: 10px; font-family: 'Roboto'; font-size: 16px;" name="note" v-model="note" placeholder="Schreibe hier deine Notiz..." rows="5" required></textarea>

        <div class="action-buttons">
          <button class="cancel-btn" @click="showNote = false">Abbrechen</button>
          <button class="reject-btn" @click="rejectPost">Ablehnen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PostComponent',
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showNote: false,
      note: ""
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    approvePost() {
      this.$emit('approve', this.post.postId)
    },
    rejectPost() {
      if (this.note !== "") {
        this.$emit('reject', this.post.postId, structuredClone(this.note))
        this.showNote = false
      } else {
        alert('Du musst eine Notiz angeben.')
      }
    },
    formatDateTime(dateString) {
      if (!dateString) return 'Nicht geplant';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          return 'Ungültiges Datum';
        }
        
        return new Intl.DateTimeFormat('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }).format(date);
      } catch (error) {
        console.error('Datum Formatierungsfehler:', error);
        return 'Ungültiges Datum';
      }
    },
    handleResize() {
      this.$forceUpdate();
    }
  }
})
</script>

<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

@media only screen and (max-width: 768px) {
  .note-modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .preview-container {
    width: 80px;
    height: 100px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media only screen and (min-width: 768px) {
  .note-modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 600px;
    height: auto;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .preview-container {
    width: 120px;
    height: 120px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.post-container {
  display: flex;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 20px;
  cursor: pointer;
}

.status-indicator {
  width: 20px;
  min-height: 100%;
  cursor: auto
}

.status-pending {
  background-color: #007656;
}

.status-approved {
  background-color: #007656;
}

.status-rejected {
  background-color: #dc3545;
}

.action-buttons {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

.approve-btn,
.cancel-btn,
.reject-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.approve-btn {
  background: #42b983;
  color: white;
}

.reject-btn {
  background: #dc3545;
  color: white;
}

.preview-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.content {
  flex: 1;
  padding: 15px;
  text-align: left;
  white-space: pre-wrap;
}

h3 {
  margin: 0 0 10px 0;
  font-size: 1.1em;
}

.post-content {
  margin: 0 0 15px 0;
  color: #666;
}

.schedule-time {
  font-size: 0.9em;
  color: #888;
  margin: 0;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  justify-content: center;
  border-left: 1px solid #eee;
  cursor: auto;
}

.action-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  min-width: 100px;
}

.approve {
  background-color: #42b983;
  color: white;
}

.approve:hover {
  background-color: #3aa876;
}

.reject {
  background-color: #dc3545;
  color: white;
}

.reject:hover {
  background-color: #c82333;
}

.no-media {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 0.9em;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.video-preview-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.play-button-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.play-button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.play-button i {
  color: white;
  font-size: 10px;
  margin-left: 2px;
}

@media only screen and (min-width: 768px) {
  .play-button {
    width: 32px;
    height: 32px;
  }

  .play-button i {
    font-size: 12px;
  }
}
</style> 